import algoliasearch from 'algoliasearch/lite';
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  Highlight,
  ClearRefinements,
  Configure,
} from 'react-instantsearch-dom';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { goTo, setContainer, AISAPPID, AISKEY, AISINDEX, getThisYear, getAuth } from '../common';

import 'instantsearch.css/themes/satellite.css';
import { connectHitInsights, connectRefinementList } from 'react-instantsearch-dom';
import aa from 'search-insights';
import {
    createInsightsMiddleware,
} from 'instantsearch.js/es/middlewares';

import "../styles/masterStyles.css";
import "../styles/testSearchStyles.css";

import { CopyrightWidget, LoadingCard } from '../components';
import { Divider, Typography } from '@material-ui/core';

const searchClient = algoliasearch(
    AISAPPID,
    AISKEY
);

const _auth = getAuth();

searchClient.initIndex(AISINDEX[0]);

aa('init', {
    appId: AISAPPID,
    apiKey: AISKEY,
});

aa('setUserToken', _auth.mcid);
const timeout = 1333;

class TestSearchClass extends Component {
    state = {
        core: [],
        loading: true,
    }

    componentDidMount = async () => {
        goTo('DIVContainer', 56);
        setTimeout(() => {
            return this.setState( {...this.state, loading: false} )
        }, timeout);
    }

    componentDidUpdate = async(prevProps, prevState) => {  }

    render() {
        if (!this.state.loading) {
            return (
                <>
                    <div className="flex-col-start anchor" style={setContainer(isBrowser)} >
                        <div
                            style={{
                                backgroundImage:"url('https://university.auanet.org/core/img/AUAUniversityWebHeader200.png')",
                                backgroundPosition: "right",
                                backgroundRepeat: "no-repeat",
                                width: "100%",
                                height: "200px",
                                margin: "0 0 8px",
                                border: "none",
                                backgroundColor: "transparent",
                                position: "relative",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "center"
                            }}
                            className="anchor"
                        >
                            <div className="auau-header-logo">
                                <a href="https://auau.auanet.org/" class="auau-logo-image">
                                    <img src="https://university.auanet.org/core/img/UniversityIcon.png" alt="aua university logo" class="nav-img pull-left" />
                                </a>
                            </div>

                            <div className="header-nav">
                                <div className="">
                                    <a 
                                        href="https://auau.auanet.org/content/core-curriculum-committee" 
                                        target="_blank"
                                    >
                                        Core Curriculum Committee
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div id="DIVContainer" className="ais-InstantSearch">
                            <Typography className="homeDividerText" style={{fontSize: "1.67em"}}>AUA Core Curriculum</Typography>
                            <Divider className="TestsDivider margin-bottom-24" />

                            <div className="hidden">
                                <Typography className="homeDividerText">
                                    <a className="text-blue" target="_blank" href="https://auau.auanet.org/core-video-submission">Call for Core Video Abstracts 2021</a>
                                </Typography>
                                
                                <p>
                                    The American Urological Association is now accepting teaching video abstracts for inclusion in the Urology Core Curriculum. Teaching video abstracts should provide step-by-step instructions for performing common urologic procedures. Each video submission will be reviewed by the Urologic Video Education Committee and the best videos in each category will be submitted to the Core Curriculum Committee for final selections. Authors of accepted videos will be notified by December 31, 2021. The accepted videos will be played in a continuous feed at the 2022 AUA Annual Meeting in New Orleans, LA. and will be published in the AUA Core Curriculum. <strong className="text-blue">Submissions will be accepted until August 31, 2021.</strong>
                                </p>

                                <Divider className="TestsDivider margin-bottom-24" />
                            </div>

                            <InstantSearch 
                                indexName={AISINDEX[0]} 
                                searchClient={searchClient} 
                            >
                                <div className="responsive-row-between">
                                    <div 
                                        style={{
                                            width: '25vw'
                                        }}
                                        className="flex-col-start"
                                    >
                                        <Typography className="homeDividerText">AUA Core Topics</Typography>

                                        <CustomRefinementList 
                                            attribute="topic"
                                            limit={50} 
                                        />
                                    </div>
                                    <div 
                                        style={{
                                            width: 'calc(75vw - 160px)'
                                        }}
                                        className="flex-col-start"
                                    >
                                        <Typography className="homeDividerText">AUA Core Sections</Typography>

                                        <Configure 
                                            hitsPerPage={200}
                                            enableReRanking={true}
                                            clickAnalytics={true}
                                            analytics={true}
                                            analyticsTags={['core_section_search']}
                                            distinct
                                        />

                                        <SearchBox 
                                            searchAsYouType={false}
                                            showLoadingIndicator={true}
                                            autoFocus
                                        />

                                        <Hits hitComponent={HitWithInsights} />
                                    </div>
                                </div>
                            </InstantSearch>
                        </div>
                        <CopyrightWidget 
                            begin={2014}
                            year={getThisYear()}
                            textAlign={'center'}
                            className="width100 margin-top-24" 
                        />
                    </div>
                </>
            );
        } else {
           return ( <LoadingCard /> )
        }
    }
}

const aisSearch = (data, user) => {
    let _obj = {
        userToken: user.mcid,
        eventName: 'Core Section Clicked',
        index: user.index,
        queryID: data.__queryID,
        objectIDs: [data.objectID],
        positions: [data.__position],
    }
    return _obj;
}

const Hit = ({hit, insights}) => {
    let obj = {
        pathname:'/corecontent',
        data: {
            id: hit.sectionid,
            keywords: "",
            path: "/corecontent",
            text: hit.name
        },
        prevLoc:'/home',
    }

    let _obj = {};
    
    _obj.mcid = _auth.mcid;
    _obj.key = _auth.key;
    _obj.index = AISINDEX[0];

    const aisobj = aisSearch(hit, _obj);

    const aisEventClick = async (insights, obj) => {
        try {
            await insights('clickedObjectIDsAfterSearch', {
                eventName: 'Core Section Clicked',
                userToken: aisobj.userToken,
                queryID: aisobj.queryID,
                objectIDs: aisobj.objectIDs,
                positions: aisobj.positions,
                index: aisobj.index
            });
        } catch (e) {
            try {
                await aa('clickedObjectIDs', aisobj);
            } catch (err) {
                // console.log(err);
            }
        }
    }

    if (hit.webUri !== '') {
        return (
            <div 
                className="flex-col-start width100"
            >
                <a
                    onClick={() => 
                        aisEventClick(insights, obj)
                    }
                    href={hit.webUri}
                    className='width100'
                >
                    <div className="hit-name width100 flex-row-between">
                        <div 
                            className="ais-width67"
                        >
                            <Highlight attribute="name" hit={hit} />
                        </div>

                        <div 
                            className="ais-width33"
                        >
                            <Highlight className='text-normal text-small text-right' attribute="publishdt" hit={hit} />
                        </div>
                    </div>
                    <div className="hit-description width100">
                        <Highlight attribute="topic" hit={hit} />
                    </div>
                </a>
            </div>
        )
    } else {
        return null;
    }
}

const RefinementList = ({
    items,
    isFromSearch,
    refine,
    searchForItems,
    createURL,
}) => {
    function sorter (a,b) {
        let comparison = 0;
        if (a.label.toUpperCase() > b.label.toUpperCase()) {
            comparison = 1;
        } else if (b.label.toUpperCase() > a.label.toUpperCase()) {
            comparison = -1;
        }
        return comparison;
    }
    
    const sorted = items.sort(sorter);

    return (
        <ul 
            style={{
                position: 'relative',
                width: 'calc(100% - 0px)',
                padding: "0",
                margin: "0",
                listStyle: "none",
                // boxShadow: "2px 2px 4px rgba(0,0,0,0.16)"
            }}
        >
            {sorted.map((item, index) => (
                <li 
                    id={`filter-button-${index}`}
                    key={item.label}
                    onClick={event => {
                        event.preventDefault();
                        refine(item.value);
                    }}
                    className="aua-li"
                    style={{ 
                        color: item.isRefined ? 'white' : '#00567a',
                        backgroundColor: item.isRefined ? '#00567a' : 'transparent',
                        padding: item.isRefined ? '8px' : '8px 0'
                    }}
                >
                    {isFromSearch ? (
                        <Highlight attribute="label" hit={item} />
                    ) : (
                        item.label
                    )} {' '}
                    ({item.count})
                </li>
            ))}
        </ul>
    )
};

const HitWithInsights = connectHitInsights(aa)(Hit);
const CustomRefinementList = connectRefinementList(RefinementList);

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    const { user_details, sync, auth_feedback } = state.auth;
    const { pagecount, core } = state.data;
    return {
        user_details, pagecount, core, sync, auth_feedback
    };
};

const TestSearchScreen = connect(mapStateToProps, { 
    
})(
    TestSearchClass
);

export { TestSearchScreen };
